import React, {ComponentType, FC} from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
  Location,
  NavigateFunction,
  NavigateOptions,
  Params,
} from 'react-router-dom';

export type WithNewRouterProps = {
  location: Location;
  history: {
    push: NavigateFunction;
    replace: (url: string, options?: NavigateOptions) => void;
  };
  match: {
    params: Params<string>;
  };
  searchParams: URLSearchParams;
  setSearchParams: ReturnType<typeof useSearchParams>[1];
};

function withNewRouter<P>(
  Component: ComponentType<P & WithNewRouterProps>,
): FC<P> {
  const Wrapper: React.FC<P> = props => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    return (
      <Component
        {...props}
        location={location}
        history={{
          push: navigate,
          replace: (url, options) => navigate(url, {replace: true, ...options}),
        }}
        match={{params}}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
    );
  };

  return Wrapper;
}

export default withNewRouter;
